import * as React from 'react';

import {Card} from '../card/card';
import {LoadingPage} from '../loading-page/loading-page';

import {MeetingCustomizer} from './meeting-customizer';
import type {Props as MeetingCustomizerProps} from './meeting-customizer';
import type {PageConfig} from './types';

type Props = MeetingCustomizerProps & {
    pageConfig: PageConfig | null | undefined;
};

export function MeetingCustomizerWrapper(props: Props) {
    const {pageConfig, ...meetingCustomizerProps} = props;

    return (
        <Card hasBorder={true} fitHeight={true} overflowVisible={true}>
            <div className='flex flex-dir-col pad-8 gap-16'>
                {!pageConfig ? (
                    <LoadingPage />
                ) : (
                    <MeetingCustomizer pageConfig={pageConfig} {...meetingCustomizerProps} />
                )}
            </div>
        </Card>
    );
}
